export const PROGRAM_STATUS = {
  "Under Review": {
    label: "Under Review",
    color: "bg-yellow-500",
    key: "under_review",
  },
  Rejected: {
    label: "Rejected",
    color: "bg-red-500",
    key: "rejected",
  },
  Approved: {
    label: "Approved",
    color: "bg-green-500",
    key: "approved",
  },
};
